import React from 'react'

const FrameworkItem = ({ item }) => {
    return (
        <li className="border-line-h">
            <div className="name">{item.name}</div>
            <div className="progress">
                <div className="percentage" style={{ width: `${item.value}%` }}></div>
            </div>
        </li>
    )
}

export default FrameworkItem